import { render, staticRenderFns } from "./_audio-bar.vue?vue&type=template&id=b38ffc86&scoped=true&"
import script from "./_audio-bar.vue?vue&type=script&lang=ts&"
export * from "./_audio-bar.vue?vue&type=script&lang=ts&"
import style0 from "./_audio-bar.vue?vue&type=style&index=0&id=b38ffc86&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38ffc86",
  null
  
)

export default component.exports